import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import { Link } from "gatsby";
import Animation from "./animation";
import animationData1 from "../json/wave-lines-1.json";
import animationData2 from "../json/wave-lines-2.json";
import animationData3 from "../json/wave-lines-3.json";
import animationData4 from "../json/wave-lines-4.json";
import "../styles/hide-scrollbar.css";
import "../styles/home-slides.css";
import "react-horizontal-scrolling-menu/dist/styles.css";
import "../styles/student-opps.css";

const initiativeFeatures = [
  {
    title: "Daylong <br />Programs",
    description:
      "<p>Explore career paths and meet mentors</p><ul> <li><a href=\"/student-opportunities/day-long-programs/job-shadowing-program/\">Job Shadowing ➝</a></li><li><a href=\"/student-opportunities/day-long-programs/recruiting-forums/\">Recruiting Forums ➝</a></li> <li><a href=\"/student-opportunities/day-long-programs/career-fair/\">Career Fairs ➝</a></li><li><a href=\"/student-opportunities/day-long-programs/exploring-future-careers/\">Exploring Future Careers ➝</a></li><li><a href=\"/student-opportunities/day-long-programs/uchicago-stock-pitch-competition/\">UChicago Stock Pitch Competition ➝</a></li></ul>",
    speed: ".25",
    animationData: animationData1,
    mixBlendMode: "multiply",
    opacity: "0.5",
  },

  {
    title: "Weeklong<br />Programs",
    description:
      "<p>Learn new skills and grow your network</p><ul><li><a href=\"/student-opportunities/week-long-programs/treks/\">Career Treks ➝</a></li><li><a href=\"/student-opportunities/week-long-programs/career-exploration-week/\">Career Exploration Week➝</a></li><li><a href=\"/student-opportunities/week-long-programs/careers-in-the-humanities-week/\">Careers in the Humanities Week➝</a></li><li><a href=\"https://tradingcompetition.uchicago.edu/\" target=\"_blank\">UChicago Trading Competition ➝</a></li><li><a href=\"/student-opportunities/week-long-programs/uchicago-private-markets-program/\">UChicago Private Markets Program ➝</a></li></ul>",
    speed: ".5",
    animationData: animationData2,
    mixBlendMode: "luminosity",
    opacity: "0.5",
  },
  {
    title: "Monthlong<br /> Programs",
    description:
      "<p>Build your resume and gain experience</p><ul><li><a href=\"/student-opportunities/month-long-programs/jeff-metcalf-internship-program/\">Jeff Metcalf Internship Program ➝</a></li><li><a href=\"/student-opportunities/month-long-programs/metcalf-clinics/\">Metcalf Clinics ➝</a></li><li><a href=\"/student-opportunities/month-long-programs/doing-business-in-the-middle-east/\">Doing Business in the Middle East ➝</a></li><li><a href=\"/student-opportunities/month-long-programs/wanxiang-ambassador-fellows-program/\">Wanxiang Ambassador Fellows Program ➝</a></li><li><a href=\"/student-opportunities/month-long-programs/uchicago-impact-competition/\">Chicago Impact Competition ➝</a></li></ul>",
    speed: ".5",
    animationData: animationData3,
    mixBlendMode: "luminosity",
    opacity: "0.5",
  },
  {
    title: "Yearlong<br />Programs",
    description:
      "<p>Take a deep dive into your field of interest</p><ul><li><a href=\"/student-opportunities/one-and-multi-year-programs/full-time-jobs/\">Full-Time Jobs ➝</a></li><li><a href=\"/student-opportunities/one-and-multi-year-programs/uchicago-advanced-scholars-4-1-masters-programs/\">Advanced Scholars \"4+1\" Master's Programs ➝</a></li><li><a href=\"/careers-in/entrepreneurship/college-new-venture-challenge/\">College New Venture Challenge ➝</a></li><li><a href=\"/student-opportunities/one-and-multi-year-programs/first-year-career-cohorts/\">First-Year Career Cohorts ➝</a></li><li><a href=\"/student-opportunities/grant-programs-internships-and-careers/stamps-scholars-program/\">Stamps Scholars Program ➝</a></li></ul>",
    speed: ".5",
    animationData: animationData4,
    mixBlendMode: "luminosity",
    opacity: "0.2",
  },
];

export default function StudentOpps() {
  return (
    <>
      <Container fluid>
        <Container id="scroller-home">
          <Row>
            <Col>
              <h2>Student Opportunities</h2>
              <p>Get Experience, Discover Your Passion</p>
            </Col>
          </Row>
          <Row>
            <Row>
              {initiativeFeatures.map((newsItem, index) => (
                <Col xs={6} lg={3} className="card-container">
                  <Card
                    itemId={`element-${index}`}
                    key={`element-${index}`}
                    title={newsItem.title}
                    description={newsItem.description}
                    imageUrl={newsItem.image_url}
                    link={newsItem.link}
                    speed={newsItem.speed}
                    mixBlendMode={newsItem.mixBlendMode}
                    opacity={newsItem.opacity}
                    animationData={newsItem.animationData}
                    //   onClick={handleClick(`element-${index}`)}
                    //   selected={isItemSelected(`element-${index}`)}
                  />
                </Col>
              ))}
            </Row>
          </Row>
        </Container>
      </Container>
    </>
  );

  function Card({
    // onClick,
    // selected,
    title,
    description,
    imageUrl,
    itemId,
    link,
    speed,
    animationData,
    mixBlendMode,
    opacity,
  }) {
    // const visibility = useContext(VisibilityContext);
    // const visible = visibility.useIsVisible(itemId, true);

    return (
      <div
        //   onClick={() => onClick(itemId)}
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: "#ffffff",
          padding: "0px",
          cursor: "pointer",
          display: "block",
          flex: "1",
          position: "relative",
          overflow: "hidden",
        }}
        tabIndex={0}
      >
        <div className="card">
          <Animation
            speed={speed}
            animationData={animationData}
            mixBlendMode={mixBlendMode}
          />

          {link && imageUrl && (
            <a href={link}>
              <img src={imageUrl} alt={title || "Image"} />
            </a>
          )}

          {title && (
            <h3
              dangerouslySetInnerHTML={{
                __html: link ? `<a href="${link}">${title}</a>` : title,
              }}
            />
          )}

          {description && (
            <p dangerouslySetInnerHTML={{ __html: description }} />
          )}
        </div>
      </div>
    );
  }
}
